import HomeView, { HomeProvider } from "./pages/home/Home";
import InvoiceView from "./pages/invoice/Invoice";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <HomeProvider>
      <Routes>
        <Route exact path={"/"} element={<HomeView />} />
        <Route path={"/invoice"} element={<InvoiceView />} />
      </Routes>
    </HomeProvider>
  );
}

export default App;